
































import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import Brand from "@/api/Brand";
import CompareSearch from "@/api/Compare/CompareSearch";
import FormOption from "@/api/Form/FormOption";

@Component
export default class CompareModalHeader extends Vue {
  @Prop() private attributeSet!: AttributeSet;
  @Prop() private brands!: Brand[];
  @Prop({default: true}) private isMobile!: boolean;

  private compareSearch: CompareSearch | null = null;
  private compareSearchInitialized = false;

  closeCompareModal() {
    this.$emit('compare-close-modal');
  }

  mounted() {
    if (this.attributeSet.attributeSetId) {
      this.compareSearch = new CompareSearch(this.attributeSet.attributeSetId);
      this.compareSearchInitialized = true;

      const searchStringInputWrapper: Vue = this.$refs.searchstring as Vue;
      const searchStringInputWrapperElement: Element = searchStringInputWrapper.$el;
      const searchStringInputs: HTMLElement[] = Array.from(searchStringInputWrapperElement.getElementsByTagName("input"));
      searchStringInputs.forEach((searchStringInput: HTMLElement)=>{
        searchStringInput.focus();
      });
    }
  }

  get brandOptions() {
    if (this.brands) {
      const options = this.brands.map(brand => new FormOption(brand.brandId?.toString(), brand.name));
      options.unshift(new FormOption(null, "تمامی برندها"))
      return options;
    }
    return null;
  }

  get searchPlaceholder() {
    if (this.attributeSet) {
      if(this.isMobile){
        return  "جستجوی " + this.attributeSet.name;
      }
      return this.attributeSet.name + " مورد نظر خود را جستجو کنید...";
    }
    if(this.isMobile){
      return  "جستجوی کالا";
    }
    return "کالای مورد نظر خود را جستجو کنید...";
  }

  @Watch('compareSearch.brandId')
  compareSearchBrandChanged(newValue: number, oldValue: number) {
    if (newValue != oldValue) {
      if (this.compareSearchInitialized) {
        this.$emit('compare-search-changed', this.compareSearch);
      }
    }
  }

  @Watch('compareSearch.searchString')
  compareSearchStringChanged(newValue: string, oldValue: string) {
    if (newValue != oldValue) {
      if (this.compareSearchInitialized) {
        this.$emit('compare-search-changed', this.compareSearch);
      }
    }
  }
}
